(function () {
    'use strict';

    angular
        .module('app')
        .component('concertCardWithStats', {
           templateUrl: 'components/directives/concert_card_with_stats/view.concert_card_with_stats.html',
           bindings: {
                tours: '<',
                concert: '<',
                upcomingConcerts: '<',
                promotionTargets: '<',
               onUpdate: '&',
           },
           controller: ['$scope', '$state', '$log', '$http', ConcertCardWithStatsController]
        });


    function ConcertCardWithStatsController($scope, $state, $log, $http) {
        const ctrl = this;

        ctrl.state = $state;
        ctrl.actionToggle = false;
        ctrl.showCreateTour = false;
        ctrl.showAddRemoveConcertFromTour = false;

        ctrl.$onInit = function () {
            ctrl.is_host = ctrl.concert.is_band_admin == 0;
            ctrl.is_artist = ctrl.concert.is_band_admin != 0;
            var type = ctrl.is_host ? 'space' : 'band';

            ctrl.cardImage = '/uploads/' + (ctrl.concert.band_image_hash ? 'bands/' + ctrl.concert.band_slug + '/' + ctrl.concert.band_image_hash : 'concerts/' + ctrl.concert.concert_slug + '/1') + '_md.jpeg';
            ctrl.promotionTargets.filter(function(o){return o.promotion_target_type_object_type == type})
            ctrl.promotion_targets = ctrl.promotionTargets.filter(function(o){return o.promotion_target_type_object_type == type || o.promotion_target_type_object_type == 'lowfi'});
            ctrl.promotion_targets_completed = ctrl.promotionTargets.filter(function(o) {
                return o.promotion_target_type_object_type == type && ctrl.isTargetCompleted(o)
            }).length +1;
        }
        
        ctrl.isTargetCompleted = function(target) {
            if(target.promotion_target_type_object_type == 'lowfi') {
                return true;
            }
            if(target && ctrl.concert && ctrl.concert.promotion_target_types) {
                return ctrl.concert.promotion_target_types.split(",").find(
                    function (o) {return o == target.promotion_target_type_id}
                ) != undefined;
            } else {
                return false;
            }
        };

        ctrl.completeTarget = function(target) {
            if(ctrl.concert.promotion_target_types && ctrl.concert.promotion_target_types.length > 0) {
                ctrl.concert.promotion_target_types += "," + target.promotion_target_type_id;
            } else {
                ctrl.concert.promotion_target_types = target.promotion_target_type_id.toString();
            }
            ctrl.promotion_targets_completed += 1;
            $http.post('api/concert/complete_promotion_target',{
                concert_id: ctrl.concert.concert_id, 
                promotion_target_type_id: target.promotion_target_type_id
            });
        };

        // When a tour is saved, just trigger the onUpdate function.
        // This could also be solved with a service
        ctrl.tourSave = function() {
            $log.debug('Tour was saved');
            $scope.$applyAsync(() => {
                ctrl.showCreateTour = false;
            });
            ctrl.onUpdate();
        }

        ctrl.tourAddRemoveConcertSave = function() {
            $log.debug('Concert was assigned/deassigned to/from tour');
            $scope.$applyAsync(() => {
                ctrl.showAddRemoveConcertFromTour = false;
            });
            ctrl.onUpdate();
        }

        ctrl.isLastYear = function(date) {
            return (moment(date).isValid()) ? !(moment().isSame(moment(date), 'year')) : false;
        }
    }
})();